import React, { useEffect } from "react";
import blockStyle from "../Block";
import navLinker from "../pageState/observer/navLinker";
import "./scheduleBlock.css";
import "../Block.css";
import scheduleData from "./scheduleData.json";

var ScheduleBlock = React.forwardRef((props, ref) => {
    var id = "schedule-block";
    useEffect(() => {
        navLinker(ref.current, props.setBlock, id);
    }, []);

    return (
        <div style={blockStyle()} className="block" id={id} ref={ref}>
            <div className="stack">
                <h1 className="main-heading faded text-main">Schedule</h1>
                <div className="schedule-table">
                    {scheduleData.map((daySchedule, index) => (
                        <ScheduleTable key={daySchedule.day} daySchedule={daySchedule} index={index}/>
                    ))}
                </div>
                <RegistrationInfo />
            </div>
        </div>
    );
});

const ScheduleTable = ({ daySchedule, index }) => (
    <div key={index} className="day-schedule">
        <h2>{daySchedule.day}</h2>
        {daySchedule.events.map((event, idx) => (
            <div key={idx}>
                <p className="time">{event.time}</p>
                <p className="event">{event.event}</p>
            </div>
        ))}
    </div>
);

const RegistrationInfo = () => (
    <div className="registration-text">
        <h3>For companies, the registration dates are as follows:</h3>
        <ul>
            <li><h3>Early-Bird Discounted Pricing Deadline: August 10th, 12 am MDT</h3></li>
            <li><h3> Final Deadline: September 1st, 12 am MDT</h3></li>
        </ul>
        <h3 className="colored-text">
            Students should use the link to register to attend Aether. This is completely for our records. 
            This info will be shared on our{" "}
            <a
                href="https://discord.gg/Dgd4hXA4eP"
                target="_blank"
                rel="noopener noreferrer"
            >
                discord already
            </a>{" "}
            - join if you haven't already!
        </h3>
    </div>
);

export default ScheduleBlock;
